// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


Vue.use(Antd)

Vue.config.productionTip = false
import {Empty ,Upload ,Spin ,Tag,DatePicker ,Row,Col,InputNumber,Select ,Icon,Menu ,Avatar ,Checkbox ,Divider, Modal,Pagination,Table,Input,Button, message } from 'ant-design-vue';
Vue.use(Empty);
Vue.use(Upload);
Vue.use(Spin);
Vue.use(Tag);
Vue.use(DatePicker);
Vue.use(Row);
Vue.use(Col);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Icon);
Vue.use(Menu); 
Vue.use(Avatar);
Vue.use(Checkbox);
Vue.use(Divider);
Vue.use(Modal);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(Input);
Vue.use(Button);

Vue.prototype.$message = message;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js